<template>
  <section>
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="shippers-search-section"
        id="shippers-search-section"
      >
        <el-form
          id="shippers-search-section-form"
          class="search-section-form"
          :model="searchForm"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
        >
          <el-row :gutter="10">
           <el-col :span="8">
            <el-form-item
              :label="$t('shipper.shipper')"
              prop="shipperAccountId"
              class="shipper-filter shipper-wrp">
                <autocomplete
                  :model.sync="searchForm.shipperAccountId"
                  :url="urlShipperAutocomplete"
                  labelField="name"
                  labelFieldLastWithDash="number"
                  :selectAction="handleSearch"
                  :enterKeyAction="handleSearch"
                  :clearAction="handleSearch"
                  :classCss="null"
                  valueField="id"
                  id="searchForm-shipper"
                  ref="search-shipper-list"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('shipper.warehouse')">
                <outbound-warehouse-select
                  v-model="searchForm.warehouseId"
                  @change="handleSearch"
                  :includeOptionAll="true"/>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('shipper.shipperGroup')">
                <shipper-group-select
                  v-model="searchForm.shipperGroupId"
                  @change="handleSearch"
                  :includeOptionAll="true"
                  :includeOptionNone="true"/>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('shipper.cutoffGroup')">
                <shipper-cutoff-group
                  v-model="searchForm.shipperCutoffGroupId"
                  @change="handleSearch"
                  :include-option-all="true"
                  :include-option-none="true"
                  ref="shipperCutoffGroupFilter"
                ></shipper-cutoff-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('shipper.cutoffExempt')">
                <shipper-cutoff-exempt
                    v-model="searchForm.shipperCutoffExempt"
                    @change="handleSearch"
                    :include-option-all="true"
                ></shipper-cutoff-exempt>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('shipper.active')">
                <el-select v-model="searchForm.active" @change="handleSearch">
                  <el-option
                      v-for="item in activeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24" class="text-align-end">
              <el-tooltip
                  :content="$t('common.search')"
                  class="item"
                  effect="dark"
                  placement="top-start"
              >
                <el-button
                    id="shippers-search-section-form-button"
                    class="button-action-default"
                    @click="handleSearch"
                    icon="el-icon-search"
                    size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import apiConstants from '@/utils/apiConstants';
import constants from '@/utils/constants';
import Autocomplete from '@/components/Autocomplete';
import OutboundWarehouseSelect from '@/views/routing/components/OutboundWarehouseSelect';
import ShipperGroupSelect from '@/components/ShipperGroup/ShipperGroupSelect';
import ShipperCutoffGroup from '@/views/warehouse/shippers/components/ShipperCutoffGroup';
import ShipperCutoffExempt from '@/views/warehouse/shippers/components/ShipperCutoffExempt';

export default {
  name: 'shippersSearchSection',
  components: {
    ShipperCutoffExempt,
    ShipperCutoffGroup,
    Autocomplete,
    OutboundWarehouseSelect,
    ShipperGroupSelect
  },
  data() {
    return {
      activeCollapsibleName: ['shippers-search-section'],
      isOpen: ['shippers-search-section'],
      searchForm: {
        warehouseId: null,
        shipperAccountId: null,
        shipperGroupId: null,
        shipperCutoffGroupId: null,
        shipperCutoffExempt: null,
        active: constants.STATUS_BOOLEAN.active.value
      },
      urlShipperAutocomplete: apiConstants.END_POINTS.ACCOUNTS.SHIPPERS,
      activeOptions: [constants.STATUS_BOOLEAN.yes, constants.STATUS_BOOLEAN.no]
    };
  },
  methods: {
    handleSearch() {
      this.$store.dispatch('account/searchShippers', this.searchForm);
    }
  },
  mounted() {
    if (this.$route.query) {
      if (this.$route.query.shipperCutoffGroupId && this.$route.query.shipperCutoffGroupName) {
        this.searchForm.shipperCutoffGroupId = this.$route.query.shipperCutoffGroupId;
        this.$nextTick(() => {
          this.$refs.shipperCutoffGroupFilter.setSelectedShipperCutoffGroup(this.$route.query.shipperCutoffGroupName);
        });
      }
    }
    this.handleSearch();
  }
};
</script>
